import { ToolsTokenError } from "./toolsAuth";

// Whether the global `createApi({ onError })` must stay silent. The insights
// session reports its own token errors, and the Tools token module has already
// reported a failed mint once (design add-tools-token-auth D3).
//
// A Tools failure is recognised by the error itself, not its message: a Tools
// REST 503 carries the same "temporarily unavailable" text but is a plain axios
// error, and it must still be toasted.
export const isSilencedApiError = (message: string, cause: unknown): boolean =>
  message === "Token is expired"
  || message === "Token is invalid"
  || cause instanceof ToolsTokenError;
